module.exports = __webpack_public_path__ + "img/ykdx-logo.15d106f2.png";